// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1TTHX","description":"PatientConsentPreview_description__1J_bZ"};